import { Link } from "react-router-dom";
import { Sparkles, X, Lock } from "lucide-react";

/**
 * Renders an upgrade prompt when the supplier is blocked by their plan limit.
 * Trigger from supplier dashboard when add/edit is denied.
 */
export default function UpgradeModal({ onClose, currentTier = "starter", reason = "limit", message }) {
  const headlineMap = {
    limit: "You've hit your plan limit.",
    past_due: "Your trial has ended.",
    cancelled: "Subscription cancelled.",
  };
  const subMap = {
    limit: "Upgrade to add more part listings and reach more SA mechanics.",
    past_due: "Add a card to continue listing parts.",
    cancelled: "Re-subscribe to add and edit listings again.",
  };

  return (
    <div
      data-testid="upgrade-modal"
      className="fixed inset-0 z-50 bg-black/50 grid place-items-center p-4"
      onClick={onClose}
    >
      <div onClick={(e) => e.stopPropagation()} className="bg-white border border-neutral-200 max-w-md w-full p-6 relative">
        <button
          onClick={onClose}
          data-testid="upgrade-modal-close"
          className="absolute top-3 right-3 text-neutral-400 hover:text-neutral-900 p-1"
        >
          <X size={18} />
        </button>

        <div className="w-10 h-10 grid place-items-center bg-[#FF5100]/10 text-[#FF5100] mb-3">
          {reason === "limit" ? <Sparkles size={20} /> : <Lock size={20} />}
        </div>

        <div className="text-xs font-mono-tech tracking-[0.25em] text-[#FF5100] mb-1">
          {currentTier.toUpperCase()} PLAN
        </div>
        <h2 className="font-display text-2xl font-extrabold leading-tight mb-2">
          {headlineMap[reason] || "Upgrade required"}
        </h2>
        <p className="text-sm text-neutral-600 mb-1">
          {message || subMap[reason]}
        </p>
        <p className="text-[12px] text-neutral-500 mb-5">
          All paid plans use PayFast — secure, ZAR billing, cancel anytime.
        </p>

        <div className="flex gap-2">
          <button
            type="button"
            onClick={onClose}
            className="flex-1 h-11 border border-neutral-200 hover:border-neutral-300 text-xs uppercase tracking-wider font-bold"
          >
            Not now
          </button>
          <Link
            to="/pricing"
            data-testid="upgrade-modal-cta"
            onClick={onClose}
            className="flex-1 h-11 inline-flex items-center justify-center gap-1.5 bg-[#FF5100] hover:bg-[#E64A00] text-white text-xs uppercase tracking-wider font-bold"
          >
            See plans
          </Link>
        </div>
      </div>
    </div>
  );
}
